// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__card {
  border: 1px solid #474747;
  box-shadow: none;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__cardHeader {
  background-color: #ffffff;
  color: var(--colors-yuzu-black);
  padding: 6px 10px !important;
  border-bottom: 1px solid rgb(160, 160, 160);
  display: flex;
  align-items: center;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__cardTitleContainer {
  display: flex;
  align-items: center;
  position: relative;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__linkToEpisode {
  position: absolute;
  right: 0;
  top: 0;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__textContainer {
  text-align: center;
  width: 100%;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__shots {
  font-size: 12px;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__cardContent {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 15px;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__cardStats {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-self: end;
  flex: 1;
  width: 100%;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__remainingDays {
  margin-right: 5px;
  font-weight: 600;
  text-align: center;
  width: 17%;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__tasksData {
  margin-left: 5px;
  text-align: center;
  width: 17%;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__taskPercent {
  font-weight: bold;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__taskPart {
  font-size: 10px;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__linkIcon {
  font-size: 14px;
  padding: 5px;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Project/ProductionManagement/Dashboards/Widgets/StatusWidget/styles.scss"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gBAAgB;AAGlB;;AAEA;EAEE,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;EAC5B,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,OAAO;EACP,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB","sourcesContent":[".card {\n  border: 1px solid #474747;\n  box-shadow: none;\n  // min-width: 350px;\n  // box-shadow: 1px 1px 4px 1px #8a8a8a !important;\n}\n\n.cardHeader {\n  // background-color: #ededed;\n  background-color: #ffffff;\n  color: var(--colors-yuzu-black);\n  padding: 6px 10px !important;\n  border-bottom: 1px solid rgb(160, 160, 160);\n  display: flex;\n  align-items: center;\n}\n\n.cardTitleContainer {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.linkToEpisode {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.textContainer {\n  text-align: center;\n  width: 100%;\n}\n\n.shots {\n  font-size: 12px;\n}\n\n.cardContent {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-bottom: 15px;\n}\n\n.cardStats {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  align-self: end;\n  flex: 1;\n  width: 100%;\n}\n\n.remainingDays {\n  margin-right: 5px;\n  font-weight: 600;\n  text-align: center;\n  width: 17%;\n}\n\n.tasksData {\n  margin-left: 5px;\n  text-align: center;\n  width: 17%;\n}\n\n.taskPercent {\n  font-weight: bold;\n}\n\n.taskPart {\n  font-size: 10px;\n}\n\n.linkIcon {\n  font-size: 14px;\n  padding: 5px;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__card`,
	"cardHeader": `app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__cardHeader`,
	"cardTitleContainer": `app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__cardTitleContainer`,
	"linkToEpisode": `app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__linkToEpisode`,
	"textContainer": `app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__textContainer`,
	"shots": `app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__shots`,
	"cardContent": `app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__cardContent`,
	"cardStats": `app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__cardStats`,
	"remainingDays": `app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__remainingDays`,
	"tasksData": `app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__tasksData`,
	"taskPercent": `app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__taskPercent`,
	"taskPart": `app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__taskPart`,
	"linkIcon": `app-pages-Project-ProductionManagement-Dashboards-Widgets-StatusWidget-___styles__linkIcon`
};
export default ___CSS_LOADER_EXPORT___;
